import type { FloatingPosition } from './types';

export function getFixedPositionStyles(
  pos: FloatingPosition,
  containerRect: DOMRect | null,
  bottomOffset: number
): Record<string, number> {
  if (containerRect) {
    const bottom = Math.max(0, window.innerHeight - containerRect.bottom + bottomOffset);
    return {
      bottom,
      ...(pos === 'right'
        ? { right: Math.max(0, window.innerWidth - containerRect.right + bottomOffset) }
        : { left: Math.max(0, containerRect.left + bottomOffset) }),
    };
  }
  return { [pos]: bottomOffset, bottom: bottomOffset };
}

export function getOverlayBounds(
  containerRect: DOMRect | null
): { top: number; left: number; right: number; bottom: number } | { inset: number } {
  if (containerRect) {
    return {
      top: containerRect.top,
      left: containerRect.left,
      right: Math.max(0, window.innerWidth - containerRect.right),
      bottom: Math.max(0, window.innerHeight - containerRect.bottom),
    };
  }
  return { inset: 0 };
}
